import { doAttention } from '@/attention';
export function swing(el, duration = undefined, options = {}) {
    return doAttention(el, 'swing', duration, options);
}
//# sourceMappingURL=swing.js.map